import {Product, QueryOptionsType} from '@framework/types';
import {API_ENDPOINTS} from '@framework/utils/api-endpoints';
import http from '@framework/utils/http';
import {useInfiniteQuery} from '@tanstack/react-query';

type PaginatedProduct = {
  data: Product[];
  paginatorInfo: any;
};
const fetchProducts = async ({direction, pageParam: page, queryKey}: any) => {
  const query = queryKey.find((item: any) => typeof item != "string")
  const {
    limit,
    newQuery: {category, sort_by, kosher, kosher_pesach, on_sale, q: search, hide_out_of_stock, manufacturer}
  } = query

  const {data} = await http.get(`${API_ENDPOINTS.PRODUCTS}`,
      {
        params: {
          limit,
          category: category,
          page,
          sort_by,
          direction,
          kosher,
          on_sale,
          kosher_pesach,
          search,
          hide_out_of_stock,
          manufacturer
        }
      });

  return {
    data: data.data as Product[],
    paginatorInfo: {
      hasNextPage: data.data.length > 0,
      nextPageUrl: data.data.length > 0 ? page + 1 : null,
    },
  };
};

const usePaginatedProductsQuery = (options: QueryOptionsType) => {
  return useInfiniteQuery<PaginatedProduct, Error>({
    queryKey: [API_ENDPOINTS.PRODUCTS, options],
    queryFn: fetchProducts,
    initialPageParam: 0,
    getNextPageParam: ({ paginatorInfo }) => paginatorInfo.nextPageUrl,
  });
};

export {usePaginatedProductsQuery, fetchProducts};
